<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-10 13:44:40
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\BlockLeave\BlockLeavePolicy\BlockLeavePolicy.vue
 * @最后编辑: Please set LastEditors
 * @最后修改时间: 2022-05-05 10:01:23
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_BlockLeavePolicy_list_title')"
    pad="0"
    :addBtn="hasBtn('add-admin-block-leave-policy-group')"
    @new="toNew"
    filterable
    @filter="
      (val) => {
        filterPageData = val;
      }
    "
    :exportBtn="hasBtn('export-admin-block-leave-policy-group')"
    :importBtn="hasBtn('import-admin-block-leave-policy-group')"
    :import-options="{
      api: '/block-leave-group/import/',
      templateUrl:
        'https://assets.essencehr.io/web/ess-business/assets/block-leave-group-import-template.xlsx',
      success: (result) => {
        getList(null, 1, $tableSetting.perPageSize, () => {
          $store.dispatch('resetTable', new Date().getTime());
        });
      },
    }"
    @export="onExport"
  >
    <!-- 筛选 -->
    <template v-slot:top-selection="{ filter }">
      <Selections2
        :objects="filterObjects"
        small-chip
        @filter="
          filter();
          toFilter(1, filter);
        "
        @update="
          (prop, value, selected) => {
            $fliterValue(filterObjects, prop, value, selected);
          }
        "
        @reset="
          (apply) => {
            $fliterValue(filterObjects, null, null);
            if (apply) {
              filter();
              toFilter(1, filter);
            }
          }
        "
      />
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :height="$vuetify.breakpoint.height - 275 - 48"
        :items="desserts"
        :filter-page-data="filterPageData"
        :showSelect="showSelect"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback, data) => {
            getList(data, page, perpage, callback);
          }
        "
      >
        <template v-slot:item.block_leave_group_name="{ item }">
          <div
            class="text--primary table-title"
            :title="$getCommonLangValue(item.block_leave_group_name)"
          >
            {{ $getCommonLangValue(item.block_leave_group_name) }}
          </div>
        </template>
        <template v-slot:item.block_leave_group_code="{ item }">
          <div class="text--primary table-title">
            {{ item.block_leave_group_code }}
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :delBtn="hasBtn('delete-admin-block-leave-policy-group')"
            :viewBtn="hasBtn('view-admin-block-leave-policy-group')"
            :editBtn="hasBtn('edit-admin-block-leave-policy-group')"
            :title="$t('label_essweb_BlockLeavePolicy_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toEdit"
          />
        </template>
      </Tabler>
    </template>
    <!-- content -->
    <!-- tools -->
    <template v-slot:tools-main></template>
    <!-- tools -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "BlockLeaveGroup",
  computed: {},
  data() {
    return {
      search: "",
      showSelect: false,
      selected: [],
      totalCount: 0,
      headers: [
        {
          text: "label_essweb_BlockLeavePolicy_list_BlockLeaveGroupNameLabel",
          sortable: false,
          align: "start",
          value: "block_leave_group_name",
          filter: (value, search, item) => {
            if (!this.search) return true;
            return (
              item.block_leave_group_name
                .toString()
                .toLocaleUpperCase()
                .indexOf(this.search.toLocaleUpperCase()) != -1
            );
          },
        },
        {
          text: "label_essweb_BlockLeavePolicy_form_BlockLeaveGroupCodeLabel",
          value: "block_leave_group_code",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
      filterObjects: [
        {
          type: "string",
          sequence: 0,
          name: "name",
          position: "right",
          label: "label_essweb_BlockLeavePolicy_list_BlockLeaveGroupNameLabel",

          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "string",
          sequence: 1,
          name: "code",
          position: "right",
          label: "label_essweb_BlockLeavePolicy_form_BlockLeaveGroupCodeLabel",

          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
      ],
      org_start_month: null,
      org_min_days: null,
      filterPageData: null,
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(null, 1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    activated(refresh) {
      const that = this;
      if (refresh == 0) {
        this.filterable = false;
        this.$fliterValue(this.filterObjects, null, null);
        // if (this.page !== null) {
        this.desserts = [];
        this.getList(null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        // }
      }
      if (refresh == 1) {
        if (this.page !== null) {
          this.toFilter(null, () => {});
        } else {
          this.toFilter(1, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
        }
      }
    },
    toFilter(tab, callback) {
      const that = this;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "name") {
          data["block_leave_group_name"] = item.value;
        }
        if (item["name"] == "code") {
          data["block_leave_group_code"] = item.value;
        }
      });
      if (tab) {
        this.getList(data, 1, this.$tableSetting.perPageSize, callback);
      } else {
        this.getList(
          data,
          this.page ? this.page : 1,
          this.pagesize ? this.pagesize : this.$tableSetting.perPageSize,
          callback
        );
      }
    },
    onExport() {
      const that = this;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "name") {
          data["block_leave_group_name"] = item.value;
        }
        if (item["name"] == "code") {
          data["block_leave_group_code"] = item.value;
        }
      });
      this.$Request({
        method: "POST",
        table: "ess_lv_block_leave_group",
        url: "/block-leave-group/export/",
        data: data,
        type: "export",
        export_title: this.$t("label_essweb_BlockLeavePolicy_list_title"),
      });
    },
    toNew: function () {
      this.$toPage(
        "/admin/block-leave-policy/add/" +
          this.$aesEncrypt(
            JSON.stringify({
              start_month: this.org_start_month,
              min_days: this.org_min_days,
            })
          )
      );
    },
    getList: function (data, page, perpage, callback) {
      const that = this;
      if (data) {
        data["cpage"] = page;
        data["pagesize"] = perpage;
      }
      this.$Request({
        method: "POST",
        table: "ess_lv_block_leave_group",
        url: "/block-leave-group/get-list/",
        data: data ? data : { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        if (res.data.length) {
          this.org_start_month = res.data[0]?.start_month ?? null;
          this.org_min_days = res.data[0]?.min_days ?? null;
        }
        that.totalCount = res.totalcount;
        callback ? callback(page, perpage, data) : null;
      });
    },
    toDelete: function (id) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_block_leave_group",
        url: "/block-leave-group/delete/",
        data: { uuids: id },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_BlockLeavePolicy_list_deleteBlockLeavePolicySuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== id);
      });
    },
    toEdit: function (uuid, action) {
      this.$toPage(
        (action == "edit"
          ? "/admin/block-leave-policy/edit/"
          : "/admin/block-leave-policy/detail/") + uuid
      );
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
  },
};
</script>
